import { ComposedTheme, registerDefaultsForModule } from '@glu/theming';
import legacy from './themes/legacyTheme';
import ash from './themes/ashTheme';

const themes = { ash, legacy };

const theme = (currentTheme: ComposedTheme) => themes[currentTheme.name](currentTheme);

registerDefaultsForModule('tabs', theme);

export default theme;
